(function () {
  var PREFERRED_API_URL = 'https://script.google.com/macros/s/AKfycbwGLv6ID0IllXpHkWHtLy5nTUqxCd6yietTkLCCnxeuMIAhvU3an3hKx9gX8o8X-plx/exec';
  var PREFERRED_API_ID = 'AKfycbwGLv6ID0IllXpHkWHtLy5nTUqxCd6yietTkLCCnxeuMIAhvU3an3hKx9gX8o8X-plx';
  var ALL_SLOTS = [
    '11:00 AM',
    '11:30 AM',
    '12:00 PM',
    '12:30 PM',
    '01:00 PM',
    '01:30 PM',
    '02:00 PM',
    '02:30 PM',
    '03:00 PM',
    '03:30 PM',
    '04:00 PM',
    '04:30 PM',
    '05:00 PM',
    '05:30 PM',
    '06:00 PM',
    '06:30 PM',
    '07:00 PM'
  ];

  function initAll() {
    document.querySelectorAll('[data-tavya-vc-root]').forEach(initVideoCallPopup);
  }

  function initVideoCallPopup(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var configuredApiUrl = String(root.dataset.apiUrl || '').trim();
    var apiUrl = configuredApiUrl.indexOf(PREFERRED_API_ID) > -1 ? configuredApiUrl : PREFERRED_API_URL;
    var maxCategories = Number(root.dataset.maxCategories || 2);
    var timezoneLabel = root.dataset.timezoneLabel || 'Asia/Kolkata (UTC+05:30)';
    var modal = root.querySelector('[data-tavya-vc-modal]');
    var overlay = root.querySelector('[data-tavya-vc-overlay]');
    var form = root.querySelector('[data-tavya-vc-form]');
    var submitBtn = root.querySelector('[data-submit-booking]');
    var errorBox = root.querySelector('[data-error]');
    var categoryError = root.querySelector('[data-category-error]');
    var dateGrid = root.querySelector('[data-date-grid]');
    var timeGrid = root.querySelector('[data-time-grid]');
    var confirmBox = root.querySelector('[data-confirm-box]');
    var availabilityLoader = root.querySelector('[data-availability-loading]');
    var emptyBox = root.querySelector('[data-slot-empty]');
    var confirmDefaultText = submitBtn ? submitBtn.textContent : 'Confirm booking';
    var bookingText = root.dataset.bookingText || 'Booking...';
    var refreshTimer = null;

    var state = {
      name: '',
      phone: '',
      language: '',
      categories: [],
      selectedDateISO: '',
      selectedDateLabel: '',
      selectedTime: '',
      availableSlots: [],
      busySlots: [],
      availabilityLoaded: false,
      availabilityFailed: false,
      availabilityRequestId: 0
    };

    function openPopup() {
      if (!modal) return;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      showStep(1);
      startRefreshTimer();
      window.setTimeout(function () {
        var firstInput = modal.querySelector('input, select, button');
        if (firstInput) firstInput.focus();
      }, 60);
    }

    function closePopup() {
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.hidden = true;
      document.documentElement.style.overflow = '';
      stopRefreshTimer();
    }

    function showStep(step) {
      root.querySelectorAll('.tavya-vc-step').forEach(function (el) {
        el.classList.toggle('tavya-vc-step-active', el.dataset.step === String(step));
      });

      root.querySelectorAll('[data-progress-step]').forEach(function (el) {
        el.classList.toggle('is-active', Number(el.dataset.progressStep) === Math.min(Number(step), 3));
      });

      if (Number(step) === 3) startRefreshTimer();
    }

    function setError(message) {
      if (errorBox) errorBox.textContent = message || '';
    }

    function setCategoryError(message) {
      if (categoryError) categoryError.textContent = message || '';
    }

    function validateStep1() {
      var fd = new FormData(form);
      var name = String(fd.get('name') || '').trim();
      var phone = String(fd.get('phone') || '').replace(/\D/g, '');
      var language = String(fd.get('language') || '').trim();

      if (!name) {
        window.alert('Please enter your name.');
        return false;
      }

      if (!/^[6-9]\d{9}$/.test(phone)) {
        window.alert('Please enter a valid 10 digit Indian mobile number.');
        return false;
      }

      if (!language) {
        window.alert('Please select your preferred language.');
        return false;
      }

      state.name = name;
      state.phone = phone;
      state.language = language;
      return true;
    }

    function validateStep2() {
      var checked = Array.from(root.querySelectorAll('input[name="categories"]:checked')).map(function (input) {
        return input.value;
      });

      setCategoryError('');

      if (!checked.length) {
        setCategoryError('Please select at least 1 collection.');
        return false;
      }

      if (checked.length > maxCategories) {
        setCategoryError('Please select only up to ' + maxCategories + ' collections.');
        return false;
      }

      state.categories = checked;
      return true;
    }

    function updateCategoryLimit() {
      var checked = root.querySelectorAll('input[name="categories"]:checked').length;
      root.querySelectorAll('input[name="categories"]').forEach(function (input) {
        input.disabled = !input.checked && checked >= maxCategories;
      });
    }

    function getIndiaParts() {
      var parts = new Intl.DateTimeFormat('en-IN', {
        timeZone: 'Asia/Kolkata',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).formatToParts(new Date());
      var lookup = {};
      parts.forEach(function (part) {
        lookup[part.type] = part.value;
      });
      return lookup;
    }

    function getIndiaDate() {
      var parts = getIndiaParts();
      return new Date(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
    }

    function getIndiaTodayISO() {
      return toISODate(getIndiaDate());
    }

    function getIndiaCurrentMinutes() {
      var parts = getIndiaParts();
      var hour = Number(parts.hour || 0);
      if (hour === 24) hour = 0;
      return hour * 60 + Number(parts.minute || 0);
    }

    function toISODate(date) {
      return [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0')
      ].join('-');
    }

    function formatDateLabel(date) {
      return new Intl.DateTimeFormat('en-IN', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        timeZone: 'Asia/Kolkata'
      }).format(date).replace(',', '');
    }

    function parseSlotMinutes(slot) {
      var match = String(slot).match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
      if (!match) return 0;
      var hour = Number(match[1]);
      var minute = Number(match[2]);
      var period = match[3].toUpperCase();
      if (period === 'PM' && hour !== 12) hour += 12;
      if (period === 'AM' && hour === 12) hour = 0;
      return hour * 60 + minute;
    }

    function isPastSlot(dateISO, slot) {
      if (dateISO !== getIndiaTodayISO()) return false;
      return parseSlotMinutes(slot) <= getIndiaCurrentMinutes();
    }

    function renderDates() {
      if (!dateGrid) return;
      dateGrid.innerHTML = '';
      setError('');
      setEmpty(false);
      clearTimes();

      var today = getIndiaDate();
      var added = 0;
      var offset = 0;

      while (added < 6 && offset < 14) {
        var date = new Date(today);
        date.setDate(today.getDate() + offset);
        var isToday = offset === 0;
        offset += 1;

        if (date.getDay() === 0) continue;

        var iso = toISODate(date);
        var label = isToday ? 'Today' : formatDateLabel(date);
        var formatted = formatDateLabel(date).split(' ');
        var weekday = formatted[0] || '';
        var dayMonth = formatted.slice(1).join(' ') || label;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tavya-vc-date-btn';
        btn.dataset.iso = iso;
        btn.dataset.label = label;
        btn.innerHTML = '<span>' + weekday + '</span><strong>' + (isToday ? 'Today' : dayMonth) + '</strong>';
        btn.addEventListener('click', function () {
          selectDate(this);
        });
        dateGrid.appendChild(btn);
        added += 1;
      }
    }

    function selectDate(button) {
      state.selectedDateISO = button.dataset.iso || '';
      state.selectedDateLabel = button.dataset.label || state.selectedDateISO;
      state.selectedTime = '';
      state.availableSlots = [];
      state.busySlots = [];
      state.availabilityLoaded = false;
      state.availabilityFailed = false;

      dateGrid.querySelectorAll('button').forEach(function (btn) {
        btn.classList.toggle('active', btn === button);
      });

      setError('');
      setEmpty(false);
      renderTimes();
      updateSubmitState();
      loadAvailability(state.selectedDateISO);
      startRefreshTimer();
    }

    function buildQuery(params) {
      var search = new URLSearchParams();
      Object.keys(params).forEach(function (key) {
        var value = params[key];
        if (value === undefined || value === null || value === '') return;
        if (Array.isArray(value)) {
          search.set(key, value.join(', '));
        } else {
          search.set(key, String(value));
        }
      });
      return search.toString();
    }

    function jsonpRequest(params, timeoutMs) {
      return new Promise(function (resolve, reject) {
        var callbackName = 'tavyaVcCallback_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
        var script = document.createElement('script');
        var separator = apiUrl.indexOf('?') === -1 ? '?' : '&';
        var timeout = window.setTimeout(function () {
          cleanup();
          reject(new Error('Request timed out.'));
        }, timeoutMs || 15000);

        function cleanup() {
          window.clearTimeout(timeout);
          try {
            delete window[callbackName];
          } catch (error) {
            window[callbackName] = undefined;
          }
          if (script.parentNode) script.parentNode.removeChild(script);
        }

        window[callbackName] = function (data) {
          cleanup();
          resolve(data || {});
        };

        script.onerror = function () {
          cleanup();
          reject(new Error('Unable to reach booking service.'));
        };

        params.callback = callbackName;
        params._ = Date.now();
        script.src = apiUrl + separator + buildQuery(params);
        document.body.appendChild(script);
      });
    }

    function setLoading(isLoading) {
      if (availabilityLoader) availabilityLoader.hidden = !isLoading;
    }

    function setEmpty(isEmpty) {
      if (emptyBox) emptyBox.hidden = !isEmpty;
    }

    function clearTimes() {
      if (timeGrid) timeGrid.innerHTML = '';
    }

    async function loadAvailability(dateISO) {
      var requestId = state.availabilityRequestId + 1;
      state.availabilityRequestId = requestId;
      setLoading(true);

      try {
        var data = await jsonpRequest({ action: 'availability', date: dateISO }, 15000);
        if (requestId !== state.availabilityRequestId) return;

        if (!data || data.status !== 'success') {
          throw new Error((data && data.message) || 'Calendar availability error.');
        }

        state.availableSlots = Array.isArray(data.availableSlots) ? data.availableSlots : [];
        state.busySlots = Array.isArray(data.busySlots) ? data.busySlots : [];
        state.availabilityLoaded = true;
        state.availabilityFailed = false;
        setError('');
        renderTimes();
      } catch (error) {
        if (requestId !== state.availabilityRequestId) return;
        state.availabilityLoaded = false;
        state.availabilityFailed = true;
        setError('Slots are shown for selection. Tavya calendar will securely confirm the slot when you book.');
        renderTimes();
      } finally {
        if (requestId === state.availabilityRequestId) {
          setLoading(false);
          updateSubmitState();
        }
      }
    }

    function getUnavailableSlots() {
      var unavailable = {};
      ALL_SLOTS.forEach(function (slot) {
        if (isPastSlot(state.selectedDateISO, slot)) unavailable[slot] = true;
      });

      state.busySlots.forEach(function (slot) {
        unavailable[slot] = true;
      });

      if (state.availabilityLoaded && state.availableSlots.length) {
        ALL_SLOTS.forEach(function (slot) {
          if (state.availableSlots.indexOf(slot) === -1) unavailable[slot] = true;
        });
      }

      return unavailable;
    }

    function applyUnavailableStyle(btn) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-booked');
      btn.style.background = '#4f2f1b';
      btn.style.borderColor = '#4f2f1b';
      btn.style.color = 'rgba(255, 250, 242, 0.58)';
      btn.style.cursor = 'not-allowed';
      btn.style.opacity = '0.78';
      btn.title = 'Already booked or unavailable';
    }

    function renderTimes() {
      clearTimes();
      var unavailable = getUnavailableSlots();
      var availableCount = 0;

      ALL_SLOTS.forEach(function (slot) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tavya-vc-time-btn';
        btn.textContent = slot;
        btn.dataset.slot = slot;

        if (unavailable[slot]) {
          applyUnavailableStyle(btn);
          if (state.selectedTime === slot) state.selectedTime = '';
        } else {
          availableCount += 1;
          btn.addEventListener('click', function () {
            state.selectedTime = slot;
            timeGrid.querySelectorAll('button').forEach(function (timeBtn) {
              timeBtn.classList.toggle('active', timeBtn === btn);
            });
            updateSubmitState();
          });
        }

        if (state.selectedTime === slot && !unavailable[slot]) {
          btn.classList.add('active');
        }

        timeGrid.appendChild(btn);
      });

      setEmpty(availableCount === 0);
      updateSubmitState();
    }

    function updateSubmitState() {
      if (!submitBtn) return;
      var unavailable = getUnavailableSlots();
      submitBtn.disabled = !(state.selectedDateISO && state.selectedTime && !unavailable[state.selectedTime]);
    }

    function markSelectedSlotUnavailable() {
      if (!state.selectedTime) return;
      if (state.busySlots.indexOf(state.selectedTime) === -1) {
        state.busySlots.push(state.selectedTime);
      }
      state.selectedTime = '';
      renderTimes();
    }

    function buildBookingPayload() {
      return {
        name: state.name,
        phone: '+91' + state.phone,
        language: state.language,
        categories: state.categories,
        date: state.selectedDateISO,
        time: state.selectedTime,
        timezone: 'Asia/Kolkata',
        pageUrl: window.location.href,
        source: 'Tavya popup locked slot mode',
        userAgent: navigator.userAgent
      };
    }

    function showBookingSuccess() {
      if (confirmBox) {
        confirmBox.innerHTML = state.selectedDateLabel + '<br>' + state.selectedTime + '<br>' + timezoneLabel;
      }

      if (state.busySlots.indexOf(state.selectedTime) === -1) {
        state.busySlots.push(state.selectedTime);
      }

      showStep(4);
    }

    function isTransportError(error) {
      var message = error && error.message ? error.message : '';
      return /unable to reach|timed out|load booking service|request failed/i.test(message);
    }

    function submitBookingFallback(payload) {
      var fallbackPayload = {
        name: payload.name,
        phone: payload.phone,
        language: payload.language,
        categories: payload.categories,
        date: payload.date,
        time: payload.time,
        timezone: payload.timezone,
        pageUrl: payload.pageUrl,
        source: 'Tavya popup no-cors fallback',
        userAgent: payload.userAgent
      };

      return fetch(apiUrl, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify(fallbackPayload),
        keepalive: true
      });
    }

    async function submitBooking() {
      var unavailable = getUnavailableSlots();
      if (!state.selectedDateISO || !state.selectedTime || unavailable[state.selectedTime]) {
        setError('Please choose an available slot.');
        return;
      }

      setError('');
      submitBtn.disabled = true;
      submitBtn.textContent = bookingText;

      var payload = buildBookingPayload();

      try {
        var data = await jsonpRequest(Object.assign({
          action: 'book',
        }, payload), 20000);

        if (!data || data.status !== 'success') {
          throw new Error((data && data.message) || 'This slot is no longer available. Please choose another slot.');
        }

        showBookingSuccess();
      } catch (error) {
        var message = error.message || 'Something went wrong. Please try again.';

        if (isTransportError(error)) {
          try {
            await submitBookingFallback(payload);
            showBookingSuccess();
            return;
          } catch (fallbackError) {
            message = 'Booking service could not be reached. Please try again or contact Tavya on WhatsApp.';
          }
        }

        setError(message);
        if (/slot|available|booked/i.test(message)) {
          markSelectedSlotUnavailable();
        } else {
          loadAvailability(state.selectedDateISO);
        }
      } finally {
        submitBtn.textContent = confirmDefaultText;
        updateSubmitState();
      }
    }

    function startRefreshTimer() {
      stopRefreshTimer();
      if (!state.selectedDateISO || !modal || modal.hidden) return;
      refreshTimer = window.setInterval(function () {
        if (!modal.hidden && state.selectedDateISO) {
          loadAvailability(state.selectedDateISO);
        }
      }, 45000);
    }

    function stopRefreshTimer() {
      if (refreshTimer) {
        window.clearInterval(refreshTimer);
        refreshTimer = null;
      }
    }

    root.tavyaVcOpenPopup = openPopup;

    root.querySelectorAll('[data-tavya-vc-open]').forEach(function (btn) {
      btn.addEventListener('click', openPopup);
    });

    root.querySelectorAll('[data-tavya-vc-close]').forEach(function (btn) {
      btn.addEventListener('click', closePopup);
    });

    root.querySelectorAll('input[name="categories"]').forEach(function (input) {
      input.addEventListener('change', updateCategoryLimit);
    });

    root.querySelectorAll('[data-step-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = Number(btn.dataset.stepNext);
        if (next === 2 && !validateStep1()) return;
        if (next === 3 && !validateStep2()) return;
        if (next === 3) renderDates();
        showStep(next);
      });
    });

    root.querySelectorAll('[data-step-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showStep(btn.dataset.stepBack);
      });
    });

    if (submitBtn) submitBtn.addEventListener('click', submitBooking);
    if (overlay) overlay.addEventListener('click', closePopup);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) closePopup();
    });

    window.addEventListener('focus', function () {
      if (modal && !modal.hidden && state.selectedDateISO) {
        loadAvailability(state.selectedDateISO);
      }
    });
  }

  if (!window.tavyaVcGlobalTriggerReady) {
    window.tavyaVcGlobalTriggerReady = true;
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-tavya-vc-open-global]');
      if (!trigger) return;
      event.preventDefault();

      var root = document.querySelector('[data-tavya-vc-root]');
      if (root && typeof root.tavyaVcOpenPopup === 'function') {
        root.tavyaVcOpenPopup();
      } else {
        window.console.warn('Tavya video call popup section is not loaded.');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
